/* eslint-disable @typescript-eslint/no-explicit-any */
import { TFunction } from 'i18next';
import { TPartnerConfigurationDetails } from 'typings/partner';
import { DEFAULT_TRANSLATIONS } from '../../utils/translationFunctions';

// returns the config and accepts an optional translation function
export const getInstaViewConfig = (
  t?: TFunction
): TPartnerConfigurationDetails => {
  // Use either the passed translation function or default to build-time values
  const translations = DEFAULT_TRANSLATIONS.instaview;

  // Handle translation with fallbacks to build-time defaults
  const translate = (
    key: string,
    options?: object,
    fallback?: string
  ): string => {
    if (t) {
      try {
        const translation = t(key, options as any);
        return translation !== key
          ? translation
          : fallback || translations[key as keyof typeof translations] || key;
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error);
        return (
          fallback || translations[key as keyof typeof translations] || key
        );
      }
    }
    return translations[key as keyof typeof translations] || fallback || key;
  };

  return {
    nameOfCompany: 'InstaVision',
    typeOfCompany: 'Inc.',
    singinLabel: translate('signIn', undefined, 'Sign In') as string,
    welcomeText: translate(
      'welcomeText',
      {
        partnerName: 'InstaVision'
      },
      'Welcome to InstaVision'
    ) as string,
    label: 'InstaVision',
    supportEmail: 'support@instavision.ai',
    supportEmail2: 'info@instavision.ai',
    phoneNumber: '+1 (877) 916-3025',
    companyAddress: '2244 Faraday Avenue, Carlsbad, CA 92008',
    updateDeteOfPrivacyPolicy: 'July 09, 2024',
    updateDeteOfTermsOfService: 'July 10, 2024',
    iosAppLink:
      'https://apps.apple.com/in/app/instavision-smart-safe-home/id6479250008',
    androidAppLink:
      'https://play.google.com/store/apps/details?id=ai.instaview.guardian'
  };
};

// Export a static config for bundling/tree-shaking
const instaViewConfig = getInstaViewConfig();
export default instaViewConfig;
